export default function validate(rules, value) {
  for (var i = 0; i < rules.length; i++) {
    let el = rules[i];
    if (typeof el == "boolean" && el == false) return el;
    if (typeof el == "string") return el;
    if (typeof el == "function") {
      let val = el(value);
      if (val != true) return val;
    }
  }
  return true;
}

export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}